import FeatureGates from '@atlaskit/feature-gate-js-client';

const getIsFolderContentViewEnabled = () => {
	// Exclude all tenants from the confluence_cloud_folders_experiment,
	// which are included in this gate. This is a workaround for not being
	// able to add existing experiments into a layer.
	const isNotInFoldersExperiment = !FeatureGates.checkGate(
		'confluence_cloud_folders_experiment_gate',
	);

	return (
		isNotInFoldersExperiment &&
		FeatureGates.getExperimentValue<'test' | 'control'>(
			'confluence_cloud_folders_content_view_experiment',
			'cohort',
			'control',
		) === 'test'
	);
};

export const useIsFolderContentViewEnabled = (): {
	isFolderContentViewEnabled: boolean;
} => {
	const isFolderContentViewEnabled = getIsFolderContentViewEnabled();
	return { isFolderContentViewEnabled };
};
